module.exports = __webpack_public_path__ + "img/ben_beard.4a721a21.jpg";